export function imgUrl(u) {
  if (!u) return u;
  return u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;
}
